export interface KeyFiguresRefinersConfig {
  filters: string[];
  invalid?: string[];
  search: string[];
  groupBy: string;
}

export const accountRefinerConfig: KeyFiguresRefinersConfig = {
  groupBy: 'ACCOUNT',
  filters: [
    'filter_account',
    'filter_campaign',
    'search_campaign',
    'filter_performance_group_enabled',
    'filter_adspert_portfolio_id',
    'filter_performance_group_id',
    'filter_adspert_campaign_id',
    'filter_adspert_account_id',
    'filter_optimization_type',
    'filter_goal_types',
    'filter_performance_group_optimization_type',
    'filter_performance_group_goal_types',
  ],
  invalid: [
    'filter_adgroup',
    'search_adgroup',
    'filter_criterion_type',
    'search_criterion_name',
    'filter_adspert_criterion',
    'filter_criterion_match_type',
    'filter_adspert_adgroup_id',
    'filter_criterion_status',
  ],
  search: ['account_id', 'account_name', 'account_tags_user'],
};

export const pgRefinersConfig: KeyFiguresRefinersConfig = {
  groupBy: 'PERFORMANCE-GROUP',
  filters: [
    'filter_adspert_account_id',
    'filter_account',
    'filter_campaign',
    'search_campaign',
    'filter_adspert_campaign_id',
    'filter_adspert_portfolio_id',
    'filter_performance_group_enabled',
    'filter_optimization_type',
    'filter_performance_group_optimization_type',
    'filter_performance_group_goal_types',
    'filter_goal_types',
    'filter_performance_group_id',
    'filter_adspert_performance_group_id',
  ],
  invalid: [
    'filter_adgroup',
    'filter_adspert_adgroup_id',
    'search_adgroup',
    'filter_adspert_criterion',
    'filter_criterion_status',
    'filter_criterion_match_type',
    'filter_criterion_type',
    'search_criterion_name',
  ],
  search: ['performance_group_id', 'performance_group_name'],
};

export const campaignRefinersConfig: KeyFiguresRefinersConfig = {
  groupBy: 'CAMPAIGN',
  filters: [
    'filter_adspert_performance_group',
    'filter_adspert_portfolio_id',

    'filter_campaign',
    'search_campaign',
    'filter_adspert_campaign_id',

    'filter_performance_group_enabled',
    'filter_performance_group_id',
    'filter_optimization_type',
    'filter_goal_types',
    'filter_performance_group_optimization_type',
    'filter_performance_group_goal_types',
    'filter_account',
    'filter_adspert_account_id',
  ],
  search: ['campaign_id', 'campaign_name'],
};

export const campaignAccountRefinersConfig: KeyFiguresRefinersConfig = {
  groupBy: 'CAMPAIGN',
  filters: [
    'filter_adspert_performance_group',
    'filter_adspert_portfolio_id',

    'filter_campaign',
    'search_campaign',
    'filter_adspert_campaign_id',

    'filter_performance_group_enabled',
    'filter_performance_group_id',
    'filter_optimization_type',
    'filter_goal_types',
    'filter_performance_group_optimization_type',
    'filter_performance_group_goal_types',

    'filter_adgroup',
    'filter_adspert_adgroup_id',
    'search_adgroup',

    'filter_criterion',
    'filter_adspert_criterion_id',
    'search_criterion',
    'filter_adgroup_amz_retailer_id',
  ],
  search: ['campaign_id', 'campaign_name'],
};

export const adGroupRefinersConfig: KeyFiguresRefinersConfig = {
  groupBy: 'ADGROUP',
  filters: [
    'filter_adspert_portfolio_id',

    'filter_campaign',
    'search_campaign',
    'filter_adspert_campaign_id',

    'filter_performance_group_enabled',
    'filter_performance_group_id',
    'filter_optimization_type',
    'filter_goal_types',
    'filter_performance_group_optimization_type',
    'filter_performance_group_goal_types',

    'filter_adgroup',
    'filter_adspert_adgroup_id',
    'search_adgroup',
    'filter_adgroup_amz_retailer_id',
  ],
  search: ['adgroup_id', 'adgroup_name'],
};

export const criteriaRefinersConfig: KeyFiguresRefinersConfig = {
  groupBy: 'CRITERION',
  filters: [
    'filter_adspert_portfolio_id',

    'filter_campaign',
    'search_campaign',
    'filter_adspert_campaign_id',

    'filter_performance_group_enabled',
    'filter_performance_group_id',
    'filter_optimization_type',
    'filter_goal_types',
    'filter_performance_group_optimization_type',
    'filter_performance_group_goal_types',

    'filter_adgroup',
    'filter_adspert_adgroup_id',
    'search_adgroup',

    'filter_criterion',
    'filter_adspert_criterion_id',
    'search_criterion',
    'filter_adgroup_amz_retailer_id',
  ],
  search: ['criterion_id', 'criterion_name'],
};
